// extracted by mini-css-extract-plugin
module.exports = {"row":"statusUpdates-module__row--2qyfz","message":"statusUpdates-module__message--1_7KJ"};